/**
 * /devhub/context-packs — Context packs (operator). Surface Layer (/01). REQ-001.91 DevHub UI rebuild · Phase 3.
 * Live operator panel (DevHubContextPackPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubContextPackPanel } from '../features/control-plane/DevHubContextPackPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/context-packs')({ component: ContextPacksPage });

function ContextPacksPage() {
  return (
    <DevHubPanelPage
      title="Context packs"
      subtitle="Reusable context packs assembled for grounded generation."
      status={{ label: 'live', live: true }}
    >
      <DevHubContextPackPanel />
    </DevHubPanelPage>
  );
}
